import { useState } from "react";
import { FaTimes } from "react-icons/fa";

type SendInterestModalProps = {
  closeSendInterestModal: () => void;
  profile: any;
};

const SendInterestModal = ({
  closeSendInterestModal,
  profile,
}: SendInterestModalProps) => {
  const [targetmartialId, setTargetmartialId] = useState("");
  const [targetmartialIdError, setTargetmartialIdError] = useState("");
  const [sendInterestLoading, setSendInterestLoading] = useState(false);
  const [interestDescription, setInterestDescription] = useState("");
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg p-6 w-full max-w-md max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-blue-600">Send Interest</h2>
          <button
            onClick={closeSendInterestModal}
            className="text-gray-500 hover:text-gray-700"
          >
            <FaTimes size={20} />
          </button>
        </div>

        {profile && (
          <div className="mb-4 p-3 bg-blue-50 rounded">
            <p className="text-sm text-gray-600">Sending Interest to:</p>
            <p className="font-semibold">{profile.fullName}</p>
            <p className="text-sm text-gray-600">
              Profile Martial ID: {profile.martialId}
            </p>
            <p className="text-sm text-gray-600">
              Bureau ID: {profile.bureauId}
            </p>
            <p className="text-sm text-blue-600 mt-2">
              <strong>Note:</strong> You will enter the Your Customer martial ID
              below
            </p>
          </div>
        )}

        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Enter Your Customer Martri ID *
          </label>
          <input
            type="text"
            value={targetmartialId}
            onChange={(e) => {
              setTargetmartialId(e.target.value);
              setTargetmartialIdError(""); // Clear error when user types
            }}
            placeholder={`Enter target martial ID:`}
            className={`w-full p-2 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
              targetmartialIdError ? "border-red-500" : "border-gray-300"
            }`}
            required
          />
          {targetmartialIdError && (
            <p className="text-red-500 text-sm mt-1">{targetmartialIdError}</p>
          )}
        </div>

        <div className="flex space-x-4">
          <button
            onClick={closeSendInterestModal}
            className="flex-1 py-2 px-4 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
            disabled={sendInterestLoading}
          >
            Cancel
          </button>
          {/* <button
                  onClick={handleSendInterestSubmit}
                  disabled={sendInterestLoading || !interestDescription.trim()}
                  className="flex-1 py-2 px-4 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
                >
                  {sendInterestLoading ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                      Sending...
                    </>
                  ) : (
                    "Send Interest"
                  )}
                </button> */}
        </div>
      </div>
    </div>
  );
};

export default SendInterestModal;
